/**
 * Generates a URL-friendly slug from FAQ data
 *
 * @param {Object} faq - The FAQ object
 * @param {string} faq.faq_title - The FAQ title (may contain HTML)
 * @returns {string} A URL-friendly slug
 */
export const generateFaqSlug = (faq) => {
  const text = faq?.faq_title;
  if (!text) return '';
  // Remove HTML tags
  const cleanText = text.replace(/<[^>]*>/g, '');
  return cleanText
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
